export default "__VITE_ASSET__CRVcFf5K__"